import type { DatePeriod } from 'src/Types/DatePeriod'
import { isDateRangeIncludingToday } from 'src/Utils/date'
import { getDateRange } from 'src/Features/SelectedDatePeriod/predefinedDatePeriods'

export const getHideCriticality = (datePeriod?: DatePeriod) =>
  !!datePeriod && !isDateRangeIncludingToday(getDateRange(datePeriod))
